import { PERMISSION } from './permission_data'

export type PermissionResult = 'allow' | 'deny'

export type PermissionSet = keyof typeof PERMISSION

export type UserPermissionSet = Partial<
  Record<PermissionSet, [...string[], PermissionResult]>
>

export function getPermissionResult(
  permSet: UserPermissionSet,
  permissionKey: PermissionSet,
): PermissionResult {
  return (
    <PermissionResult>permSet[permissionKey]?.slice(-1)?.[0] ??
    <PermissionResult>'deny'
  )
}

export const permissionRequest = PERMISSION
